module.exports = __webpack_public_path__ + "img/noble2.57b5e0f4.png";